import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"
import {
  getAccountVendorBills,
  getAccountVendorBill,
  createAccountVendorBill,
  updateAccountVendorBill,
  deleteAccountVendorBill,
} from "api/accountVendorBillApi"

export const ACCOUNT_VENDOR_BILL_QUERY_KEY = "account-vendor-bills"

export const useAccountVendorBills = (params = {}, enabled = true) => {
  return usePaginatedResource(
    ACCOUNT_VENDOR_BILL_QUERY_KEY,
    getAccountVendorBills,
    params,
    enabled
  )
}

export const useAccountVendorBill = (id, enabled = true) => {
  return useResourceItem(
    ACCOUNT_VENDOR_BILL_QUERY_KEY,
    getAccountVendorBill,
    id,
    enabled
  )
}

export const useCreateAccountVendorBill = () => {
  return useCreateResource(
    createAccountVendorBill,
    ACCOUNT_VENDOR_BILL_QUERY_KEY
  )
}

export const useEditAccountVendorBill = () => {
  return useEditResource(
    updateAccountVendorBill,
    ACCOUNT_VENDOR_BILL_QUERY_KEY
  )
}

export const useDeleteAccountVendorBill = () => {
  return useDeleteResource(
    deleteAccountVendorBill,
    ACCOUNT_VENDOR_BILL_QUERY_KEY
  )
}
